export const HTTPURL = process.env.REACT_APP_API_URL;
export const STUDENT_PORTAL_URL = process.env.REACT_APP_STUDENT_PORTAL_URL;
